import React, { useContext } from 'react'; // Removed unused ethers import
import { AuthContext } from '../AuthContext'; // Updated to src/AuthContext.js

const MoneyTalks = ({ walletAddress }) => {
  const { isAuthenticated, ensName, loginWithSIWE } = useContext(AuthContext) || {}; // Fallback for undefined context
  const displayName = ensName || (walletAddress ? walletAddress.substring(0, 6) + '...' : '');

  return (
    <section className="moneytalk-container futuristic-glow">
      <div
        style={{
          background: 'black',
          padding: '20px',
          borderRadius: '10px',
          boxShadow: '0 0 20px gold',
          transition: 'box-shadow 0.3s ease',
          maxWidth: '1024px',
          margin: '20px auto' // Wider width, top/bottom margin
        }}
        onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 0 40px gold')}
        onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 0 20px gold')}
      >
        <h1 style={{ fontSize: '2.5rem', textAlign: 'center' }}>MoneyTalk - Finance Discussions</h1>
        <p style={{ fontSize: '1.2rem', textAlign: 'center' }}>Exchange views on finance, DeFi, RWAs. ENS required for posting (e.g., alice.xbsys.eth).</p>
        {/* Dynamic Connection Status */}
        <div className="mb-6" style={{ backgroundColor: '#333', padding: '1rem', borderRadius: '5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="flex items-center space-x-3">
            <div className={`w-3 h-3 rounded-full ${isAuthenticated ? 'bg-green-500' : 'bg-red-500'}`}></div>
            <span className="font-medium" style={{ color: isAuthenticated ? '#00FF00' : '#FF0000' }}>
              {isAuthenticated ? `✓ Wallet Connected: ${ensName || walletAddress?.substring(0, 6) + '...' || 'Unknown'} (Authenticated)` : 'Not Connected'}
            </span>
          </div>
          {!isAuthenticated && (
            <button
              onClick={loginWithSIWE}
              style={{
                background: 'transparent',
                border: '2px solid gold',
                color: 'gold',
                padding: '15px 30px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold',
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'gold'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              Connect Wallet
            </button>
          )}
        </div>
        <iframe src="https://banksystem.co/moneytalks/node/" style={{ width: '100%', height: '1600px', border: 'none' }} title="MoneyTalks Blog"></iframe> {/* Iframe for the Drupal content */}
      </div>
    </section>
  );
};
export default MoneyTalks;
